import React from "react";
import {Stack, Typography, useMediaQuery, useTheme} from "@mui/material";

Title.defaultProps = {
    title: "PIVAN",
    subtitle: "",
    version: "",
    variant: "h1",
    subVariant: "subtitle1"
}

export default function Title(props) {
    const theme = useTheme();
    const {title, subtitle, version, variant, subVariant, ...other} = props;
    const lgDown = useMediaQuery(theme => theme.breakpoints.down('lg'));

    return (
        <Stack {...other}>
            <Typography variant={variant} textAlign={lgDown ? "center" : "start"} width="100%">
                {title}
                {version && <span style={{position: "absolute"}}>
                        <Typography
                            sx={{
                                width: "fit-content",
                                height: "fit-content",
                                bgcolor: theme.palette.mode === "light"
                                    ? theme.palette.appBar.light : theme.palette.primary.dark,
                                color: theme.palette.primary.contrastText,
                                padding: "0.4em",
                                margin: theme.spacing(1),
                                borderRadius: "0.3em",
                                fontSize: lgDown ? 9 : 11,
                                fontWeight: "bold",
                                boxShadow: 1
                            }}
                        >{version}</Typography>
                    </span>}
            </Typography>
            <Typography variant={subVariant} textAlign="center">
                {subtitle}
            </Typography>
        </Stack>
    );
}